"use client";

import api from "@/apis";
import { Loader2 } from "lucide-react";
import Link from "next/link";

export function GalleryPreview() {
    const { data: galleryItems, isLoading } = api.Gallery.Get.useQuery();

    const defaultImages = [
        "/src/jldfjldfjdfkj.jpeg",
        "/src/lkajdaldj.jpeg",
        "/src/lkajdladl.jpeg",
        "/src/team/mariu.jpeg",
    ];

    const displayImages =
        galleryItems && galleryItems.length > 0
            ? galleryItems.slice(0, 4).map((item: any) => item.src)
            : defaultImages;

    if (isLoading) {
        return (
            <div className="flex justify-center py-12">
                <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
            {displayImages.map((img: string, idx: number) => (
                <Link
                    key={idx}
                    href="/gallery"
                    className="group relative overflow-hidden rounded-lg aspect-square block"
                >
                    <img
                        src={img || "/placeholder.svg"}
                        alt="Gallery"
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors duration-300" />
                </Link>
            ))}
        </div>
    );
}
